import { useCookies } from 'react-cookie'

import { canaryCookieKey } from 'pages/_document'

export const useCanary = () => {
  const [{ [canaryCookieKey]: newAdsEnabled }] = useCookies([canaryCookieKey])

  return newAdsEnabled === '1'
}
